/* eslint-disable react/jsx-wrap-multilines */
import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import GenericListPair from 'modules/common/components/GenericListPair';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import useDebounce from 'modules/common/hooks/useDebounce';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { reactSelectFilterStyle } from 'modules/common/components/Select';
import * as actions from '../action';
import * as c from '../constant';
import NewBusinessesContent from './NewBusinessesContent';
import BusinessAuditLogs from '../components/BusinessAuditLogs';
import TaxCreditModal from '../modals/TaxCreditModal';
import BusinessModal from '../modals/BusinessModal';
import UpdateVeterinaryModal from '../modals/UpdateVeterinaryModal';
import UpdateBaseLineModal from '../modals/UpdateBaseLineModal';

const INIT_FILTER = {
  q: '',
  sort_by: 'desc',
  status: '',
  description: '',
  kind_of_ownership: '',
};

const FilterSelect = ({ label, value, options, ...rest }) => {
  return (
    <div className="d-flex flex-column mt-3 mb-1 mr-1">
      {/* <label className="form-label mb-1 text-muted">
        <h6 className="mb-0">{label}</h6>
      </label> */}
      <Select
        value={
          options.find((item) => `${value}` === `${_.get(item, 'value')}`) ||
          ''
        }
        styles={reactSelectFilterStyle}
        options={options}
        placeholder={label}
        {...rest}
      />
    </div>
  );
};

FilterSelect.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  options: PropTypes.instanceOf(Array).isRequired,
};

function NewBusinessesContainer({
  match,
  history,
  getNewBusinessesList,
  newBusinessesList,
  isLoading,
  removeNewBusinesses,
  newBusinessesListPager,
  getSingleNewBusinesses,
  ordinanceRevisionId,
  holdBusiness,
  toggleBusinessRetirement,
}) {
  const [filter, setFilter] = useState(INIT_FILTER);
  const debouncedFilter = useDebounce(filter, 500);
  const setModal = useContext(ModalContext);

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <BusinessModal ordinanceRevisionId={ordinanceRevisionId} type="NEW" />
      ),
      title: 'Add Business',
      modalSize: 'modal-xl',
    });
  };

  const handleAddTaxCredit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <TaxCreditModal
          id={data.id}
          ordinanceRevisionId={ordinanceRevisionId}
          type="NEW"
        />
      ),
      title: 'Add Tax Credit',
      modalSize: 'modal-md',
    });
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <BusinessModal
          type="EDIT"
          updateList={data.attributes}
          id={data.id}
          newBusinessesInfo={data}
          ordinanceRevisionId={ordinanceRevisionId}
        />
      ),
      title: 'Update Business',
      modalSize: 'modal-xl',
    });
  };

  const handleRemove = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to remove this business?',
      () => {
        removeNewBusinesses(data.id, () => {
          setFilter((prev) => ({
            ...prev,
            q: '',
          }));
          const id = _.get(newBusinessesList, '1.id');
          history.push(`/bpls/new-business/new-businesses/${id}`);
          getSingleNewBusinesses(id);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  useEffect(() => {
    getNewBusinessesList(debouncedFilter);
    return () => {
      setModal({ isOpen: false });
    };
  }, [JSON.stringify(debouncedFilter)]);

  useEffect(() => {
    if (ordinanceRevisionId) {
      setFilter((prev) => ({
        ...prev,
        ordinance_revision_id: ordinanceRevisionId,
      }));
    }
  }, [ordinanceRevisionId]);

  const handleOnChangeSelect = (key) => (e) => {
    const value = _.get(e, 'value', '');
    setFilter((prev) => ({
      ...prev,
      [key]: value,
      ...(key === 'status' ? { description: '' } : {}),
    }));
  };

  const handleHoldOnHold = (data) => (e) => {
    e.preventDefault();

    ConfirmAlert(
      <div>
        Are you sure, do you want to{' '}
        {_.get(data, 'attributes.is_hold') ? 'Unhold' : 'Hold'} this business?
      </div>,
      (hold_remarks) => {
        holdBusiness(data.id, { hold_remarks }, () => {
          getSingleNewBusinesses(data.id);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const handleOnRetireBusiness = (data) => (e) => {
    e.preventDefault();

    ConfirmAlert(
      <div>
        Are you sure, do you want to{' '}
        {_.get(data, 'attributes.is_retired') === 0 ? 'Retire' : 'Unretire'}{' '}
        this business?
      </div>,
      (retire_remarks) => {
        toggleBusinessRetirement(data.id, { retire_remarks }, () => {
          getSingleNewBusinesses(data.id);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const handleOnRevertBusiness = (data) => (e) => {
    e.preventDefault();

    ConfirmAlert(
      <div>
        Are you sure, do you want to{' '}
        {_.get(data, 'attributes.is_retired') === 0 ? 'Retire' : 'Unretire'}{' '}
        this business?
      </div>,
      (retire_remarks) => {
        toggleBusinessRetirement(data.id, { retire_remarks }, () => {
          getSingleNewBusinesses(data.id);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const handleLogs = (data) => (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: <BusinessAuditLogs data={data} />,
      title: 'Business Logs',
      modalSize: 'modal-lg',
    });
  };

  const handleUpdateVeterinary = (data) => (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: <UpdateVeterinaryModal data={data} id={data.id} />,
      title: 'Update Veterinary',
      modalSize: 'modal-md',
    });
  };

  const handleUpdateBaseLine = (data) => (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: <UpdateBaseLineModal data={data} id={data.id} />,
      title: 'Update Base Line',
      modalSize: 'modal-md',
    });
  };

  const handleOnChange = (key, value) => {
    setFilter((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  return (
    <div className="card-content-listing m-0 p-0">
      <Route
        path={`${match.path}/:newBusinessesId?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName="Businesses"
            // getData={getNewBusinessesList}
            // setParams={param}
            setKeyword={(e) =>
              handleOnChange(
                e?.target.name,
                e?.target.value
                // e?.target.value.length
              )
            }
            setStatusFilter={(props) =>
              handleOnChange('transaction_status', props?.value)
            }
            // statusFilter
            // statusOptions={c.KIND_OF_OWNERSHIP}
            // setStatusFilter={handleOnChangeSelect(
            //   _.get(formData, 'kind_of_ownership')
            // )}
            // status={_.get(filter, 'kind_of_ownership') || ''}
            customFilter={
              <div className="d-flex align-items-center justify-content-end flex-wrap">
                <FilterSelect
                  label="Status"
                  value={_.get(filter, 'status')}
                  options={c.BUSINESS_STATUS}
                  onChange={handleOnChangeSelect('status')}
                />
                {!!_.get(filter, 'status') && (
                  <FilterSelect
                    label="Description"
                    value={_.get(filter, 'description')}
                    options={
                      c.BUSINESS_DESCRIPTION_BY_STATUS[
                        _.get(filter, 'status')
                      ] || []
                    }
                    onChange={handleOnChangeSelect('description')}
                  />
                )}
                <FilterSelect
                  label="Business Type"
                  value={_.get(filter, 'kind_of_ownership')}
                  options={c.KIND_OF_OWNERSHIP}
                  onChange={handleOnChangeSelect('kind_of_ownership')}
                />
              </div>
            }
            keyword={_.get(filter, 'q') || ''}
            keywordPlaceholder="Search..."
            listName="newBusinesses"
            label="Businesses"
            renderItem={(item) => (
              <div className="p-3 transaction-list-company">
                {_.get(item, 'attributes.business_name') || ''}
                <h4 className="mt-1 mb-0 transaction-list-name">
                  {_.get(item, 'attributes.bin')}
                </h4>
              </div>
            )}
            isLoading={isLoading}
            selected={params.newBusinessesId}
            data={newBusinessesList}
            dataPager={newBusinessesListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:newBusinessesId?`}
                    render={() => (
                      <NewBusinessesContent
                        handleAddModal={handleAddModal}
                        handleAddTaxCredit={handleAddTaxCredit}
                        handleEdit={handleEdit}
                        handleRemove={handleRemove}
                        handleHoldOnHold={handleHoldOnHold}
                        handleOnRevertBusiness={handleOnRevertBusiness}
                        handleOnRetireBusiness={handleOnRetireBusiness}
                        ordinanceRevisionId={ordinanceRevisionId}
                        handleLogs={handleLogs}
                        handleUpdateVeterinary={handleUpdateVeterinary}
                        handleUpdateBaseLine={handleUpdateBaseLine}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:newBusinessesId?`}
                  render={() =>
                    !params.business_Id && newBusinessesList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(newBusinessesList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
            handleChangePage={(page) =>
              setFilter((prev) => ({ ...prev, page }))
            }
          />
        )}
      />
    </div>
  );
}

NewBusinessesContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getNewBusinessesList: PropTypes.instanceOf(Function).isRequired,
  newBusinessesList: PropTypes.instanceOf(Array).isRequired,
  newBusinessesListPager: PropTypes.instanceOf(Object).isRequired,
  removeNewBusinesses: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  getSingleNewBusinesses: PropTypes.instanceOf(Function).isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
  holdBusiness: PropTypes.instanceOf(Function).isRequired,

  toggleBusinessRetirement: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  newBusinessesList: _.get(api, `${c.GET_NEW_BUSINESSES}.list`) || [],
  newBusinessesListPager: _.get(api, `${c.GET_NEW_BUSINESSES}.pager`) || {},
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_NEW_BUSINESSES) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(NewBusinessesContainer);
